





















































import { Component, Vue, Mixins, Watch, Prop } from 'vue-property-decorator';
import TableMixin from '@root/common/mixins/table';
import TableWidthMixin from '@root/common/mixins/table-width';
import * as api from '../../../../api/reconciliation-management';
import { IBankSelect } from './types';

@Component
export default class BanSelect extends Mixins(TableMixin, TableWidthMixin) implements IBankSelect {
  filterParam: any = {
    bankName: '',
    financialInstitution: '',
    bankNo: '',
    controlUnit: '',
    no: ''
  };

  clear() {
    this.filterParam = {
      bankName: '',
      financialInstitution: '',
      bankNo: '',
      controlUnit: '',
      no: ''
    };
  }

  search() {
    this.current = 1;
    // 清除选中
    this.selectedRowKeys = [];
    this.fetchTableData();
  }
  showSizeChangerChange(current: any, pageSize: any) {
    this.current = current;
    this.pageSize = pageSize;
    this.fetchTableData();
  }

  current: number = 1;
  pageSize: number = 10;
  total: number = 0;
  tableData: any[] = [];
  tableLoading: boolean = false;
  selectedRowKeys: string[] = [];
  selectedRows: string[] = [];
  get tableColums() {
    return [
      {
        title: '社区单元',
        dataIndex: 'controlUnit'
      },
      {
        title: '社区代码',
        dataIndex: 'villageNo'
      },
      {
        title: '银行账号',
        dataIndex: 'bankNo'
      },
      {
        title: '银行名称',
        dataIndex: 'bankName'
      },
      {
        title: '金融机构',
        dataIndex: 'financialInstitution'
      },
      {
        title: '编码',
        dataIndex: 'no'
      }
    ];
  }

  numberRender(value: number) {
    if (isNaN(value)) {
      return value;
    } else {
      const num = (value / 100).toFixed(2);
      return num.replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, '$&,');
    }
  }

  async fetchTableData() {
    try {
      if (this.tableLoading) return;
      this.tableLoading = true;

      const res = await api.getBankInfokList({
        page: this.current,
        pageSize: this.pageSize,
        ...this.filterParam
      });

      const data = res.data;
      if (data) {
        const { pageSize = 0, currPage = 0, totalPage, totalNum = 0, datas = [], total } = data;
        this.total = Number(totalNum);
        this.tableData = datas;
      }
    } catch (error) {
      this.$message.error((error && error.msg) || '系统繁忙，请稍后再试');
    } finally {
      this.tableLoading = false;
    }
  }
  onSelectChange(selectedRowKeys: string[], selectedRows: string[]) {
    this.selectedRowKeys = selectedRowKeys;
    this.selectedRows = selectedRows;
  }

  created(): void {
    if (this.selectedBank) {
      this.selectedRowKeys = [this.selectedBank.id];
    }
    this.fetchTableData();
  }

  // 公共方法
  getSelectedBank() {
    if (!this.selectedRows.length) {
      return null;
    }
    return this.selectedRows[0];
  }
}
